import type { TourDefinition } from './types'

export const TRAINEE_SOLO_TOUR_ID = 'traineeSolo'
export const TRAINEE_SOLO_TOUR_VERSION = 6

/** Onboarding for trainees with no coach assigned. */
export const TRAINEE_SOLO_TOUR: TourDefinition = {
  id: TRAINEE_SOLO_TOUR_ID,
  version: TRAINEE_SOLO_TOUR_VERSION,
  copyKey: 'traineeSolo',
  hasWelcome: true,
  autoStart: ({ user }) => !!user && !user.hasTrainees && !user.hasCoaches,
  steps: [
    {
      id: 'home',
      path: '/',
      target: 'tour-trainee-get-started',
      titleKey: 'homeTitle',
      bodyKey: 'homeBody',
      iconId: 'today',
    },
    {
      id: 'quick-access',
      path: '/',
      target: 'tour-quick-access',
      titleKey: 'quickAccessTitle',
      bodyKey: 'quickAccessBody',
      iconId: 'quickAccess',
      tipPlacement: 'above',
    },
    {
      id: 'more-personal',
      path: '/more',
      target: 'tour-more-personal',
      titleKey: 'personalTitle',
      bodyKey: 'personalBody',
      iconId: 'plan',
    },
    {
      id: 'more-create-block',
      path: '/more',
      target: 'tour-more-create-block',
      titleKey: 'createBlockTitle',
      bodyKey: 'createBlockBody',
      iconId: 'plan',
    },
    {
      id: 'more-create-program',
      path: '/more',
      target: 'tour-more-create-program',
      titleKey: 'createProgramTitle',
      bodyKey: 'createProgramBody',
      iconId: 'sets',
    },
    {
      id: 'more-account',
      path: '/more',
      target: 'tour-more-account',
      titleKey: 'accountTitle',
      bodyKey: 'accountBody',
      iconId: 'account',
    },
    {
      id: 'become-coach',
      path: '/more',
      target: 'tour-more-become-coach',
      titleKey: 'becomeCoachTitle',
      bodyKey: 'becomeCoachBody',
      iconId: 'clients',
    },
    {
      id: 'assistant',
      path: '/more',
      target: 'tour-more-assistant',
      titleKey: 'assistantTitle',
      bodyKey: 'assistantBody',
      iconId: 'assistant',
      tipPlacement: 'above',
    },
  ],
}
